/**
 * Ajuda dos campos de integracoes: o registro de chamadas e as consultas a bureau.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/integracoes': {
    'Tipo da integracao':
      'O que a chamada fez: verificacao de provedor, envio ao sistema da seguradora, boleto e outros. As consultas a bureau ficam na tela Consultas a bureau.',
    Provedor:
      'Chave do provedor chamado, como viacep, receita_cnpj (CNPJ pela BrasilAPI) ou vigidata. Deixe vazio para todos os provedores.',
    Situacao:
      'Os estados que este provedor aceita. CEP e CNPJ (BrasilAPI) ficam sempre em uso nos formularios; a situacao guarda a verificacao. A Vigidata e ligada pela plataforma e nao se configura aqui.',
    Identificacao:
      'Procura no objeto de origem, na referencia do fornecedor e na mensagem da chamada.',
  },

  '/consultas-bureau': {
    'Data inicial':
      'Primeiro dia do periodo, no horario de Brasilia. Com o filtro mandatorio, informe a data inicial e a final, ou o CNPJ.',
    'Data final': 'Ultimo dia do periodo, incluido inteiro.',
    'CNPJ consultado':
      'CNPJ completo, com ou sem mascara. Sem permissao de credito, o CNPJ aparece mascarado na lista.',
    Bureau:
      'Bureau que respondeu a consulta. O bureau ficticio aparece quando foi usado, e toda consulta dele e simulada, sem custo.',
    'Situacao da consulta':
      'Sucesso, parcial, falhou ou incerta. Incerta quer dizer que o pedido saiu e a resposta nao serviu: pode ter sido cobrada.',
  },
};
